<template>
    <va-create-layout>
        <PayWithAmazonEvent-form
            :title="title"
            :item="item"
        ></PayWithAmazonEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
